import { createContext, useContext, useEffect } from 'react'
import posthog from 'posthog-js'
import { isPerformanceAllowed, isAdvertisingAllowed } from '../lib/privacyPreferences'

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY || 'phc_tSPlAd9hjdpLrrJg0Ca2uxB0XskXDx0iazF8IDJJiWo'
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com'

/** Воронка и paywall: шлём в PostHog даже если выключены Performance cookies (иначе воронки в дашборде пустые). */
function shouldSendToPostHog(eventName) {
  if (isPerformanceAllowed()) return true
  return typeof eventName === 'string' && eventName.startsWith('funnel_')
}

const AnalyticsContext = createContext()

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext)
  if (!context) {
    throw new Error('useAnalytics must be used within AnalyticsProvider')
  }
  return context
}

export const AnalyticsProvider = ({ children }) => {
  useEffect(() => {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      loaded: (posthog) => {
        console.log('✅ PostHog loaded successfully')
      }
    })
  }, [])

  const trackEvent = (eventName, properties = {}) => {
    if (shouldSendToPostHog(eventName)) {
      try {
        posthog.capture(eventName, properties)
        console.log('📊 Event tracked:', eventName, properties)
      } catch (error) {
        console.error('❌ Error tracking event:', error, eventName, properties)
      }
    }

    // Advertising cookies — рекламные пиксели (Meta Pixel)
    if (isAdvertisingAllowed() && typeof window !== 'undefined' && window.fbq) {
      try {
        window.fbq('track', eventName, properties)
        // Стандартные события Meta для оптимизации кампаний (конверсии)
        if (eventName === 'funnel_onboarding_completed') {
          window.fbq('track', 'CompleteRegistration', { content_name: 'Sign Up' })
        }
        if (eventName === 'funnel_subscription_success') {
          window.fbq('track', 'StartTrial', { content_name: 'AstroPlus', value: 0, predicted_ltv: 0 })
        }
      } catch (error) {
        console.error('❌ Error tracking Meta Pixel event:', error)
      }
    }
  }

  const identifyUser = (userId) => {
    if (isPerformanceAllowed() && userId) {
      try {
        posthog.identify(userId)
      } catch (error) {
        console.error('❌ Error identifying user:', error)
      }
    }
  }

  const value = {
    trackEvent,
    identifyUser
  }

  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  )
}

